"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const errors_1 = require("../../errors");
const ChargeStatus_1 = require("../models/charges/ChargeStatus");
const rates_1 = require("../models/rates");
class BatchEditChargesStatusValidator {
    transactionTypes = Object.values(rates_1.TransactionType);
    chargeStatus = Object.values(ChargeStatus_1.ChargeStatus);
    _dateSchema = joi_1.default.object({
        from: joi_1.default.number().optional(),
        to: joi_1.default.number().optional(),
    });
    _chargeFilterSchema = joi_1.default.object({
        warehouseIds: joi_1.default.array().items(joi_1.default.number()).unique().optional(),
        transactionType: joi_1.default.string()
            .valid(...this.transactionTypes)
            .optional(),
        creationDate: this._dateSchema.optional(),
        confirmDate: this._dateSchema.optional(),
        statuses: joi_1.default.array()
            .items(joi_1.default.string().valid(...this.chargeStatus))
            .optional(),
        invoiceNumber: joi_1.default.string().optional(),
        eventId: joi_1.default.string().optional(),
        transactionId: joi_1.default.number().optional(),
    });
    _batchEditChargesStatusSchema = joi_1.default.object({
        filter: this._chargeFilterSchema.required(),
        status: joi_1.default.string()
            .valid(...this.chargeStatus)
            .required(),
    }).required();
    validate(charge) {
        const issues = [];
        const result = this._batchEditChargesStatusSchema.validate(charge, {
            abortEarly: false,
            convert: false,
        });
        if (result.error) {
            result.error.details.forEach((issue) => {
                switch (issue.type) {
                    case 'any.required': {
                        issues.push(new errors_1.Errors.ValidationIssue('IBatchEditChargesStatus', errors_1.Errors.ValidationErrorCode.requiredValue, issue.context?.key, undefined));
                        break;
                    }
                    case 'object.unknown': {
                        issues.push(new errors_1.Errors.ValidationIssue('IBatchEditChargesStatus', errors_1.Errors.ValidationErrorCode.notAllowed, issue.context?.label ||
                            issue.context?.key, issue.context?.value));
                        break;
                    }
                    case 'object.base': {
                        issues.push(new errors_1.Errors.ValidationIssue('IBatchEditChargesStatus', errors_1.Errors.ValidationErrorCode.invalidType, issue.context?.label ||
                            issue.context?.key, issue.context?.value));
                        break;
                    }
                    case 'string.base':
                    case 'array.base':
                    case 'number.base': {
                        issues.push(new errors_1.Errors.ValidationIssue('IBatchEditChargesStatus', errors_1.Errors.ValidationErrorCode.invalidType, issue.context?.label ||
                            issue.context?.key, issue.context?.value));
                        break;
                    }
                    case 'any.only':
                    case 'string.empty': {
                        issues.push(new errors_1.Errors.ValidationIssue('IBatchEditChargesStatus', errors_1.Errors.ValidationErrorCode.invalidValue, issue.context?.label ||
                            issue.context?.key, issue.context?.value));
                        break;
                    }
                    case 'array.unique': {
                        issues.push(new errors_1.Errors.ValidationIssue('IBatchEditChargesStatus', errors_1.Errors.ValidationErrorCode.notAllowed, issue.context?.label, issue.context?.value));
                        break;
                    }
                }
            });
        }
        if (issues.length > 0) {
            const error = new errors_1.Errors.ValidationError();
            issues.forEach((issue) => {
                error.addIssue(issue.modelType, issue.errorCode, issue.fieldName, issue.value, issue.path);
            });
            throw error;
        }
    }
}
exports.default = BatchEditChargesStatusValidator;
